module.exports = __webpack_public_path__ + "img/guest-active.9fafd3fb.png";